import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageCircle } from "lucide-react";
import { adminApi, errMsg } from "@/lib/api";
import { Btn, Panel, Pill } from "@/admin/ui";

const TONE = { sent: "green", failed: "orange", skipped: "grey" };

export const SummaryPanel = ({ date }) => {
  const [logs, setLogs] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => adminApi.get("/sales-summary/logs").then((r) => setLogs(r.data));
  useEffect(() => { load(); }, []);

  const send = async (path, params) => {
    setBusy(true);
    try {
      const { data } = await adminApi.post(path, null, { params });
      data.status === "sent" ? toast.success(`Summary sent to +91 ${data.to}`) : toast.error(`Not sent: ${data.error}`);
      load();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <Panel title="WhatsApp · 9:30 PM sales summary · 7:00 AM price reminder" className="mt-6 print:hidden" testId="summary-panel" action={
      <div className="flex flex-wrap gap-2">
        <Btn variant="outline" onClick={() => send("/price-reminder/send")} disabled={busy} data-testid="price-reminder-send-btn"><MessageCircle className="w-4 h-4 inline mr-1" />Send price reminder now</Btn>
        <Btn variant="outline" onClick={() => send("/sales-summary/send", { date })} disabled={busy} data-testid="summary-send-btn"><MessageCircle className="w-4 h-4 inline mr-1" />{busy ? "Sending…" : `Send ${date} summary now`}</Btn>
      </div>}>
      <p className="text-xs text-stone-500 mb-3">Both are sent automatically. The morning reminder is skipped if you've already confirmed today's prices. Change the number in Settings.</p>
      {logs.length === 0 && <p className="text-sm text-stone-500" data-testid="summary-logs-empty">No summaries sent yet.</p>}
      <ul className="divide-y divide-stone-200">
        {logs.map((l) => (
          <li key={l.id} className="py-2 flex flex-wrap items-center gap-2 text-sm" data-testid={`summary-log-${l.id}`}>
            <Pill tone={TONE[l.status]}>{l.status}</Pill>
            <span className="font-semibold">{l.date}</span>
            <span className="text-stone-500">{l.trigger} · {new Date(l.at).toLocaleString("en-IN")} · +91 {l.to}</span>
            {l.error && <span className="text-xs text-accent w-full">{l.error}</span>}
          </li>
        ))}
      </ul>
    </Panel>
  );
};
